import { EmpresasList } from '../Empresas/EmpresasList';

/**
 * Pagina de cargadores contractuales. Filtra Empresas con tipo='CARGADOR'.
 *
 * Hereda toda la logica del componente generico `EmpresasList`.
 */
export function CargadoresList() {
  return (
    <EmpresasList
      tipo="CARGADOR"
      titulo="Cargadores contractuales"
      subtitulo="Empresas que contratan servicios."
      botonNuevo="Nuevo cargador"
      tituloModal="Nuevo cargador contractual"
      exitoTitulo="Cargador dado de alta"
      emptyHint="No hay cargadores. Da de alta el primero con el boton de arriba."
      errorTitulo="No se pudieron cargar los cargadores"
    />
  );
}
